import { useContent } from "contexts/contentContext/contentContext";
import React from "react";
import Icon from "../Icon/Icon";
import Image from "../Image/Image";
import Tooltip from "../Tooltip/Tooltip";
import "./CheckboxElement.scss";

const CheckboxElement = ({ state, setState, checkboxLabel, checkboxTooltip }) => {
  const { getTextByKey } = useContent();
  return (
    <div className="checkbox-element-container">
      <Image
        className="input-checkbox"
        onClick={() => {
          setState(!state);
        }}
        name={state ? "checkbox-checked" : "checkbox-unchecked"}
        ext="svg"
      />
      <div className="input-label">
        <span className="span-text">{getTextByKey(checkboxLabel)}</span>
      </div>
      {checkboxTooltip && (
        <div className="input-tooltip">
          <Tooltip id={checkboxTooltip} tooltipTextKey={checkboxTooltip} top>
            <Icon name="question-circle" iconClass="tooltip-question" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default CheckboxElement;
